module.exports = __webpack_public_path__ + "static/media/note.30213643.png";